import baseUrl from './baseUrl';

const URL_EDITAR_USUARIO = `${baseUrl}/auth/edit`;

const editarUsuario = async data => {
  try {
    const response = await fetch(`${URL_EDITAR_USUARIO}/${data._id}`, {
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }
  } catch (error) {
    console.log(error);
  }
};

export default editarUsuario;
